/*
 * File: CustomerIdSearch.tsx
 * Project: papa-bear
 * -----
 * Last Modified: 13 Dec 2021 8:13:38 pm
 * -----
 * Copyright (c) 2021 Elegant Software Solutions All rights reserved.
 */

import { Space } from 'antd';
import { FancyInput } from 'components/atoms/FancyInput';
import { InlineStylesModel } from 'models/InlineStylesModel';
import React, { ChangeEvent } from 'react';
import { useDispatch } from 'react-redux';
import { setFilterCustomerId } from 'redux/salesOrder/customerSelectionFiltersSlice';
import { useDebouncedCallback } from 'use-debounce';

const styles: InlineStylesModel = {
  titleColor: {
    // color: '#2F5596'
  }
};

export const CustomerIdSearch = (): JSX.Element => {
  const dispatch = useDispatch();

  /* ****************** Functions ****************** */
  // Handle delay of searching data
  const handleInputChange = useDebouncedCallback((ev: ChangeEvent<HTMLInputElement>) => {
    dispatch(setFilterCustomerId(ev.target.value));
  }, 500);

  /* ****************** Render ****************** */
  return (
    <Space direction="vertical" size="small">
      <FancyInput onChange={handleInputChange} placeholder="Customer Id" width={150} />
    </Space>
  );
};
